module.exports = __webpack_public_path__ + "_/_/src/demo/src/catalog/items/kitchen/steel.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/demo/src/catalog/items/kitchen/steel.jpg
// module id = 581
// module chunks = 0